(function () {
  'use strict';

  var DELIVERY_PROP = 'Delivery by';

  var TIERS = [
    { key: 'standard',  buffer: 3, prop: '_delivery_standard' },
    { key: 'expedited', buffer: 2, prop: '_delivery_expedited' },
    { key: 'express',   buffer: 1, prop: '_delivery_express' }
  ];
  var STANDARD_TIER = TIERS[0];

  var DELIVERY_MAP_ATTR = '_delivery_map';
  var MAP_ENTRY_SEP = '|';
  var MAP_FIELD_SEP = '~';
  var MAP_KEY_SEP = ':';

  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
                     'July', 'August', 'September', 'October', 'November', 'December'];

  function cutoffParts() {
    var raw = (window.DeliveryDateConfig && window.DeliveryDateConfig.cutoff) || '14:30';
    var match = /^(\d{1,2}):(\d{2})$/.exec(String(raw).trim());
    var hours = match ? parseInt(match[1], 10) : 14;
    var minutes = match ? parseInt(match[2], 10) : 30;
    if (isNaN(hours) || hours < 0 || hours > 23) hours = 14;
    if (isNaN(minutes) || minutes < 0 || minutes > 59) minutes = 30;
    return { hours: hours, minutes: minutes };
  }

  function beforeCutoff(hours, minutes) {
    var cutoff = cutoffParts();
    return hours < cutoff.hours || (hours === cutoff.hours && minutes < cutoff.minutes);
  }

  function toShopTime(date) {
    var timezone = (window.DeliveryDateConfig && window.DeliveryDateConfig.timezone) || 'America/Boise';
    try {
      return new Date(date.toLocaleString('en-US', { timeZone: timezone }));
    } catch (e) {
      return new Date(date.toLocaleString('en-US', { timeZone: 'America/Boise' }));
    }
  }

  function isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  function cutoffCountdown() {
    var cutoff = cutoffParts();
    var now = toShopTime(new Date());

    var deadline = new Date(now.getTime());
    deadline.setHours(cutoff.hours, cutoff.minutes, 0, 0);

    if (!isWeekend(now) && now.getTime() < deadline.getTime()) {
      return toCountdown(deadline.getTime() - now.getTime());
    }

    var showAfterCutoff = window.DeliveryDateConfig && window.DeliveryDateConfig.countdownAfterCutoff;
    if (isWeekend(now) || !showAfterCutoff) return null;

    deadline.setDate(deadline.getDate() + 1);
    while (isWeekend(deadline)) deadline.setDate(deadline.getDate() + 1);
    return toCountdown(deadline.getTime() - now.getTime());
  }

  function toCountdown(diff) {
    if (diff <= 0) return null;
    var minutes = Math.floor(diff / 60000);
    return { hours: Math.floor(minutes / 60), minutes: minutes % 60 };
  }

  function formatCountdown(countdown) {
    var parts = [];
    if (countdown.hours > 0) parts.push(countdown.hours + (countdown.hours === 1 ? ' hour' : ' hours'));
    parts.push(countdown.minutes + (countdown.minutes === 1 ? ' min' : ' mins'));
    return 'Order within ' + parts.join(' ');
  }

  function renderCountdowns() {
    var hidden = window.DeliveryDateConfig && window.DeliveryDateConfig.showCountdown === false;
    var countdown = hidden ? null : cutoffCountdown();
    var text = countdown ? formatCountdown(countdown) : '';
    document.querySelectorAll('[data-delivery-countdown]').forEach(function (el) {
      el.textContent = text;
      el.style.display = text ? '' : 'none';
    });
  }

  function calculateProcessingDate(currentDate, daysToAdd) {
    if (isNaN(daysToAdd) || !(currentDate instanceof Date)) return '';

    var date = new Date(currentDate.getTime());
    var cst = toShopTime(date);
    var dayOfWeek = date.getDay();

    if (beforeCutoff(cst.getHours(), cst.getMinutes()) && daysToAdd > 1 && dayOfWeek !== 0 && dayOfWeek !== 6) {
      daysToAdd -= 1;
    }

    var added = 0;
    while (added < daysToAdd) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) added++;
    }
    if (date.getDay() === 0) date.setDate(date.getDate() + 1);

    return DAY_NAMES[date.getDay()] + ', ' + MONTH_NAMES[date.getMonth()] + ' ' + date.getDate();
  }

  function parseDeliveryMeta(raw) {
    if (!raw) return null;
    try {
      var data = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (!data || !data.mainProduct) return null;
      var from = parseInt(data.mainProduct.from, 10);
      var to = parseInt(data.mainProduct.to, 10);
      if (isNaN(from) || isNaN(to) || to <= 0) return null;
      return { from: from, to: to, weeks: !!data.weeks };
    } catch (e) {
      return null;
    }
  }

  function parseStorefrontMetafields(node) {
    if (!node || !node.metafields) return null;
    var byKey = {};
    node.metafields.forEach(function (mf) { if (mf) byKey[mf.key] = mf.value; });
    var from = parseInt(byKey.mw_delivery_time_from, 10);
    var to = parseInt(byKey.mw_delivery_time_to, 10);
    if (isNaN(from) || isNaN(to) || to <= 0) return null;
    return { from: from, to: to, weeks: byKey.mw_delivery_time_use_in_weeks === 'true' };
  }

  function computeDaysToAdd(meta, buffer) {
    var avg = (meta.to + meta.from) / 2;
    return Math.round((meta.weeks ? avg * 7 : avg) + buffer);
  }

  function computeTierDates(meta, now) {
    var at = now || new Date();
    var dates = {};
    TIERS.forEach(function (tier) {
      dates[tier.key] = calculateProcessingDate(at, computeDaysToAdd(meta, tier.buffer));
    });
    return dates;
  }

  function setDate(container, selector, value) {
    container.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
  }

  function mountModalToBody(modal, container) {
    if (!modal || modal.dataset.deliveryModalMounted === 'true') return;
    modal.dataset.deliveryModalMounted = 'true';
    if (container && container.id) {
      modal.dataset.deliveryModalOwner = container.id;
    }
    document.body.appendChild(modal);
  }

  function removeOrphanedDeliveryModals() {
    document.querySelectorAll('body > [data-delivery-modal][data-delivery-modal-mounted="true"]').forEach(function (modal) {
      var ownerId = modal.dataset.deliveryModalOwner;
      if (ownerId && document.getElementById(ownerId)) return;
      modal.remove();
    });
  }

  function bindModal(container) {
    if (container.dataset.deliveryBound) return;
    container.dataset.deliveryBound = '1';

    var trigger = container.querySelector('[data-delivery-modal-trigger]');
    var modal = container.querySelector('[data-delivery-modal]');
    var close = container.querySelector('[data-delivery-modal-close]');
    if (!modal) return;

    mountModalToBody(modal, container);

    function open(e) {
      if (e) e.preventDefault();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('delivery-modal--open');
      document.body.classList.add('overflow-hidden');
      if (close) close.focus();
    }
    function hide() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('delivery-modal--open');
      document.body.classList.remove('overflow-hidden');
      if (trigger) trigger.focus();
    }

    if (trigger) trigger.addEventListener('click', open);
    if (close) close.addEventListener('click', hide);
    modal.addEventListener('click', function (e) { if (e.target === modal) hide(); });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && modal.classList.contains('delivery-modal--open')) hide();
    });
  }

  function initDeliveryDate() {
    removeOrphanedDeliveryModals();

    document.querySelectorAll('[data-delivery-container]').forEach(function (container) {
      var meta = parseDeliveryMeta(container.getAttribute('data-delivery-meta'));
      if (!meta) {
        container.style.display = 'none';
        return;
      }

      var dates = computeTierDates(meta);
      setDate(container, '[data-delivery-standard-date]', dates.standard);
      setDate(container, '[data-delivery-expedited-date]', dates.expedited);
      setDate(container, '[data-delivery-express-date]', dates.express);

      container.style.display = 'block';
      bindModal(container);
    });

    renderCountdowns();
    if (!window.deliveryCountdownTimer) {
      window.deliveryCountdownTimer = setInterval(renderCountdowns, 30000);
    }
  }

  function injectDeliveryDateIntoProductForms() {
    document.querySelectorAll('[data-delivery-container]').forEach(function (container) {
      var meta = parseDeliveryMeta(container.getAttribute('data-delivery-meta'));
      if (!meta) return;

      var dates = computeTierDates(meta);
      if (!dates[STANDARD_TIER.key]) return;

      var scope = container.closest('product-info') || container.closest('.product') ||
                  container.closest('section') || document;
      var forms = scope.querySelectorAll('product-form form');
      if (!forms.length) forms = document.querySelectorAll('product-form form');

      var fields = [{ prop: DELIVERY_PROP, value: dates[STANDARD_TIER.key] }];
      TIERS.forEach(function (tier) {
        if (dates[tier.key]) fields.push({ prop: tier.prop, value: dates[tier.key] });
      });

      forms.forEach(function (form) {
        fields.forEach(function (field) {
          var name = 'properties[' + field.prop + ']';
          var input = form.querySelector('input[name="' + name + '"]');
          if (input) {
            input.value = field.value;
            return;
          }
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = field.value;
          form.appendChild(input);
        });
      });
    });
  }

  function getSectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function getCartSectionsToRender() {
    var sections = [];
    var mainCart = document.getElementById('main-cart-items');
    if (mainCart && mainCart.dataset.id) {
      sections.push({ id: 'main-cart-items', section: mainCart.dataset.id, selector: '.js-contents' });
    }
    if (document.getElementById('CartDrawer')) {
      sections.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }
    return sections;
  }

  function applyCartSections(rendered, sections) {
    if (!rendered) return;
    var drawerUpdated = false;
    sections.forEach(function (s) {
      var html = rendered[s.section];
      var container = document.getElementById(s.id);
      if (!html || !container) return;
      var inner = getSectionInnerHTML(html, s.selector);
      if (inner == null) return;
      (container.querySelector(s.selector) || container).innerHTML = inner;
      if (s.id === 'CartDrawer') drawerUpdated = true;
    });
    if (drawerUpdated) {
      setTimeout(function () {
        window.EasifyCartDrawer?.dedupeEditLinks?.();
      }, 500);
    }
  }

  function refreshCartSections() {
    var sections = getCartSectionsToRender();
    if (!sections.length) return Promise.resolve();
    var param = sections.map(function (s) { return s.section; }).join(',');
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var join = cartUrl.indexOf('?') === -1 ? '?' : '&';
    return fetch(cartUrl + join + 'sections=' + encodeURIComponent(param))
      .then(function (r) { return r.json(); })
      .then(function (rendered) { applyCartSections(rendered, sections); })
      .catch(function () {});
  }

  function metafieldsQuery(handles) {
    var fields = handles.map(function (handle, i) {
      return 'p' + i + ': product(handle: ' + JSON.stringify(handle) + ') {' +
        ' metafields(identifiers: [' +
        '{namespace: "custom", key: "mw_delivery_time_from"},' +
        '{namespace: "custom", key: "mw_delivery_time_to"},' +
        '{namespace: "custom", key: "mw_delivery_time_use_in_weeks"}' +
        ']) { key value } }';
    });
    return '{' + fields.join(' ') + '}';
  }

  function setCheckoutGate(disabled) {
    if (!window.DeliveryDateConfig || !window.DeliveryDateConfig.gateCheckout) return;
    document.querySelectorAll('.cart__checkout-button').forEach(function (button) {
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function syncCartDeliveryDates() {
    var cfg = window.DeliveryDateConfig;
    if (!cfg || !cfg.enabled || !cfg.token) return Promise.resolve();
    if (window.deliveryDateSyncing) return Promise.resolve();
    window.deliveryDateSyncing = true;
    setCheckoutGate(true);

    function release() {
      window.deliveryDateSyncing = false;
      setCheckoutGate(false);
    }

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) return;

        var metaByHandle = {};
        items.forEach(function (item) {
          if (item.handle) metaByHandle[item.handle] = null;
        });
        var handles = Object.keys(metaByHandle);

        function patchCart() {
          var cfg = window.DeliveryDateConfig || {};
          var syncLineProperties = cfg.syncCartLineProperties === true;

          if (!syncLineProperties) {
            return syncDeliveryMapFromMeta(items, metaByHandle, cart.attributes);
          }

          var changes = [];
          items.forEach(function (item) {
            var meta = metaByHandle[item.handle];
            if (!meta) return;
            var dates = computeTierDates(meta);
            if (!dates[STANDARD_TIER.key]) return;

            var existing = item.properties || {};
            var desired = {};
            desired[DELIVERY_PROP] = dates[STANDARD_TIER.key];
            TIERS.forEach(function (tier) {
              if (dates[tier.key]) desired[tier.prop] = dates[tier.key];
            });

            if (existing[DELIVERY_PROP] === desired[DELIVERY_PROP]) return;

            var properties = Object.assign({}, existing, desired);
            changes.push({ id: item.key, quantity: item.quantity, properties: properties });
          });

          if (!changes.length) {
            return syncDeliveryMapFromMeta(items, metaByHandle, cart.attributes);
          }

          var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
          var chain = changes.reduce(function (promise, change) {
            return promise.then(function () {
              return fetch(changeUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                  id: change.id,
                  quantity: change.quantity,
                  properties: change.properties,
                }),
                keepalive: true,
              }).catch(function () {});
            });
          }, Promise.resolve());

          return chain
            .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
            .then(function (fresh) {
              if (!fresh) return;
              return syncDeliveryMapFromMeta(fresh.items, metaByHandle, fresh.attributes);
            })
            .catch(function () {})
            .then(refreshCartSections);
        }

        if (!handles.length) return;

        return fetch('https://' + cfg.shopDomain + '/api/' + (cfg.apiVersion || '2024-10') + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': cfg.token
          },
          body: JSON.stringify({ query: metafieldsQuery(handles) })
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            var data = response.data || {};
            handles.forEach(function (handle, i) {
              metaByHandle[handle] = parseStorefrontMetafields(data['p' + i]);
            });
            return patchCart();
          });
      })
      .then(release, release);
  }

  function buildDeliveryMap(items) {
    var seen = {};
    var entries = [];

    (items || []).forEach(function (item) {
      var id = item && item.variant_id;
      if (!id || seen[id]) return;

      var props = item.properties || {};
      var parts = TIERS.map(function (tier) {
        var value = props[tier.prop];
        return typeof value === 'string' ? value : '';
      });
      if (!parts.some(Boolean)) return;

      seen[id] = true;
      entries.push(id + MAP_KEY_SEP + parts.join(MAP_FIELD_SEP));
    });

    return entries.join(MAP_ENTRY_SEP);
  }

  function buildDeliveryMapFromMeta(items, metaByHandle) {
    var seen = {};
    var entries = [];

    (items || []).forEach(function (item) {
      var id = item && item.variant_id;
      if (!id || seen[id]) return;

      var meta = metaByHandle[item.handle];
      if (!meta) return;

      var dates = computeTierDates(meta);
      var parts = TIERS.map(function (tier) {
        return dates[tier.key] || '';
      });
      if (!parts.some(Boolean)) return;

      seen[id] = true;
      entries.push(id + MAP_KEY_SEP + parts.join(MAP_FIELD_SEP));
    });

    return entries.join(MAP_ENTRY_SEP);
  }

  function syncDeliveryMapAttribute(items, existingAttributes) {
    var desired = buildDeliveryMap(items);
    var current = (existingAttributes || {})[DELIVERY_MAP_ATTR] || '';
    if (desired === current) return;

    var payload = { attributes: {} };
    payload.attributes[DELIVERY_MAP_ATTR] = desired;

    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  function syncDeliveryMapFromMeta(items, metaByHandle, existingAttributes) {
    var desired = buildDeliveryMapFromMeta(items, metaByHandle);
    var current = (existingAttributes || {})[DELIVERY_MAP_ATTR] || '';
    if (desired === current) return;

    var payload = { attributes: {} };
    payload.attributes[DELIVERY_MAP_ATTR] = desired;

    var updateUrl = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function () {});
  }

  function revertCartToStandardDates() {

    if (window.deliveryDateReverting) return Promise.resolve();
    window.deliveryDateReverting = true;

    function release() { window.deliveryDateReverting = false; }

    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) return;

        var changes = [];
        items.forEach(function (item) {
          var props = item.properties || {};
          var standard = props[STANDARD_TIER.prop];
          if (!standard) return;
          if (props[DELIVERY_PROP] === standard) return;

          var properties = Object.assign({}, props);
          properties[DELIVERY_PROP] = standard;
          changes.push({ id: item.key, quantity: item.quantity, properties: properties });
        });

        if (!changes.length) return;

        var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';
        return changes.reduce(function (promise, change) {
          return promise.then(function () {
            return fetch(changeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: change.id,
                quantity: change.quantity,
                properties: change.properties
              })
            }).catch(function () {});
          });
        }, Promise.resolve());
      })
      .catch(function () {})
      .then(release, release);
  }

  function refresh() {
    initDeliveryDate();
    injectDeliveryDateIntoProductForms();
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    refresh();
    window.addEventListener(
      'load',
      function () {
        syncCartDeliveryDates();
      },
      { once: true }
    );
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(refresh, 0);
    });
  }

  document.addEventListener('product-info:loaded', function () {
    setTimeout(refresh, 0);
  });

  window.DeliveryDate = window.DeliveryDate || {};
  window.DeliveryDate.refresh = refresh;
})();
